export default function LocationIcon() {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M27.9933 11.2666C26.5933 5.10659 21.22 2.33325 16.5 2.33325C16.5 2.33325 16.5 2.33325 16.4867 2.33325C11.78 2.33325 6.39334 5.09325 4.99334 11.2533C3.43334 18.1333 7.64667 23.9599 11.46 27.6266C12.8733 28.9866 14.6867 29.6666 16.5 29.6666C18.3133 29.6666 20.1267 28.9866 21.5267 27.6266C25.34 23.9599 29.5533 18.1466 27.9933 11.2666Z"
        fill="white"
      />
      <path
        d="M16.5 17.9466C18.8196 17.9466 20.7 16.0662 20.7 13.7466C20.7 11.427 18.8196 9.54663 16.5 9.54663C14.1805 9.54663 12.3 11.427 12.3 13.7466C12.3 16.0662 14.1805 17.9466 16.5 17.9466Z"
        fill="white"
      />
    </svg>
  );
}
